import './person-category-new-modal.tag'
riot.tag2('persons-categories-list', '  <catalog-tree object="ContactCategory" label-field="{&quot;name&quot;}" search="true" sortable="true" allselect="true" cols="{cols}" reload="true" add="{permission(addEdit, &quot;contacts&quot;, &quot;0100&quot;)}" children-field="{&quot;childs&quot;}" remove="{permission(remove, &quot;contacts&quot;, &quot;0001&quot;)}" handlers="{handlers}" dblclick="{permission(addEdit, &quot;contacts&quot;, &quot;1000&quot;)}" store="persons-category-list">\n    <yield to="after">\n      <span class="small">({this.userCount})</span><span class="form-inline pull-right"><i class="fa fa-envelope-o" if="{this.emailSettings}" title="Установлен код рассылки"></i><span class="f-sort" title="Вес сортировки группы">{this.sort}</span></span>\n    </yield>\n  </catalog-tree>\n', 'persons-categories-list,[riot-tag="persons-categories-list"],[data-is="persons-categories-list"]{ position: relative; display: block; } persons-categories-list treenodes .treenode,[riot-tag="persons-categories-list"] treenodes .treenode,[data-is="persons-categories-list"] treenodes .treenode{ padding: 2px; width: 100%; display: inline-block; line-height: 2.2; } persons-categories-list .f-sort,[riot-tag="persons-categories-list"] .f-sort,[data-is="persons-categories-list"] .f-sort{ margin-left: 30px; margin-right: 30px; }', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'ContactCategory';

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];

function up(e) {}

function down(e) {}

self.handlers = {
    checkMask: self.checkMask,
    checkPermission: self.checkPermission,
    permission: self.permission,
    btnup: up,
    btndown: down
};

self.addEdit = function (e) {
    var item = {};

    if (e.item && e.item.id) item = e.item;

    modals.create('person-category-new-modal', {
        type: 'modal-primary',
        item: item,
        submit: function submit() {
            var _this = this;

            API.request({
                object: 'ContactCategory',
                data: _this.item,
                method: 'Save',
                success: function success(response) {
                    observable.trigger('persons-category-reload');
                    popups.create({ title: 'Успех!', text: 'Категория сохранена!', style: 'popup-success' });
                    _this.modalHide();
                    self.tags['catalog-tree'].reload();
                }
            });
        }
    });
};
});


// WEBPACK FOOTER //
// ./pages/persons/persons-categories-list.tag